/**
 * wagmi + Reown AppKit bootstrap.
 *
 * AppKit wraps WalletConnect's modern wallet modal around wagmi's
 * hook-based state. We configure mainnet only — ASIC only lives on
 * Ethereum L1 — and provide minimal metadata for the connect dialog.
 *
 * The project ID must be provisioned at https://cloud.reown.com and
 * exposed via `VITE_WC_PROJECT_ID`. Without it, the build fails and
 * the app refuses to boot rather than shipping a broken WalletConnect
 * configuration.
 */

import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { mainnet } from "@reown/appkit/networks";
import type { AppKitNetwork } from "@reown/appkit/networks";

const projectId = import.meta.env.VITE_WC_PROJECT_ID;

if (!projectId) {
  throw new Error(
    "VITE_WC_PROJECT_ID is not set. Add it to .env.local before building.",
  );
}

export const networks: [AppKitNetwork, ...AppKitNetwork[]] = [mainnet];

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata: {
    name: "asicrouter",
    description: "ASIC-specialized DEX aggregator",
    url:
      typeof window !== "undefined"
        ? window.location.origin
        : "https://asic.coinpedia.wiki",
    icons: ["/favicon.svg"],
  },
  features: {
    analytics: false,
    email: false,
    socials: false,
    swaps: false,
    onramp: false,
  },
  themeMode: "dark",
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;
